export const TIMETABLE = '/timetable/'
export const TIMETABLE_UPDATED = `${TIMETABLE}updated` as const
export const TIMETABLE_ALL = `${TIMETABLE}all` as const
export const TIMETABLE_GENERATE = `${TIMETABLE}generate` as const
